import { finish, error } from '../../../modules/bets/actions/settle';
import api from '../../../api';
import { Amount } from 'src_common/common/amount/Amount';

export function request(dispatch, { id, accountId, legs }) {
    api.post('/bets/' + id + '/settle', { accountId, legs }).then(
        (data) => {
            data.maxBet = $appState.configState.precision.newFromOld(data.maxBet).value;
            data.payout = $appState.configState.precision.newFromOld(data.payout).value;
            return dispatch(finish(id, data));
        },
        ({ errors }) => dispatch(error(id, errors))
    );
}
